var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRegPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 80,
    viewBox: "0 0 140 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5154_54796)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 0.0195312H6.51163C2.91535 0.0195312 0 2.67266 0 5.94546V74.0936C0 77.3664 2.91535 80.0195 6.51163 80.0195H133.488C137.085 80.0195 140 77.3664 140 74.0936V5.94546C140 2.67266 137.085 0.0195312 133.488 0.0195312Z",
    fill: "#4F4C57"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5154_54796",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 128,
    height: 70
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.488 5.94531H6.51172V74.0935H133.488V5.94531Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5154_54796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.488 5.94531H6.51172V74.0935H133.488V5.94531Z",
    fill: "#625E70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9072 11.8711H52.0933V68.1674H87.9072V11.8711Z",
    fill: "#908CA0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5154_54796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 80,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRegPopup);
export default __webpack_public_path__ + "static/media/icon-reg-popup.fb16bbf8d85203fd963a734529051fcc.svg";
export { ForwardRef as ReactComponent };